import useSetState from 'utils/hooks/useSetState';

export type PostComposerFormOptions = {
  canAppendLinkFromText: boolean;
};

export const usePostComposerFormOptions = () => {
  const [options, setOptions] = useSetState<PostComposerFormOptions>({
    canAppendLinkFromText: true,
  });

  return {
    options,
    setOptions,
  };
};
